import { Grid, TextField, Button, Typography } from "@material-ui/core";
import { Card } from "@material-ui/core";
import IconButton, { IconButtonProps } from "@material-ui/core/IconButton";
import { styled } from "@material-ui/core/styles";
import ExpandMore from "@material-ui/icons/ExpandMore";
import Collapse from "@material-ui/core/Collapse";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import useCustomState from "../../hooks/State";
import { Autocomplete } from "@material-ui/lab";
import { useSelector } from "react-redux";
import Call from "../../service/API";
import { useDispatch } from "react-redux";
import { UpdateCounterTypes } from "../../store/actions";
import { useMountAPI } from "../../hooks/APICall";
import Input from "@material-ui/core/Input";

const ExpandMoree = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));

const AddCounterType = (props) => {
  const expanded = useCustomState(false);
  const handleExpandClick = () => {
    expanded.handleChange(!expanded.value);
  };

  const dispatch = useDispatch();

  const isLoading = useCustomState(true);

  const typeName = useCustomState("");
  const category = useCustomState({ title: "", id: -1 });
  const typeDescription = useCustomState("");
  const categories = useCustomState([]);
  const selectedFile = useCustomState("");
  const categoryImages = useCustomState([]);

  const typeNameError = useCustomState({ error: false, text: "" });
  const categoryError = useCustomState({ error: false, text: "" });

  const typeNameChanged = (e) => {
    typeNameError.handleChange({ error: false, text: "" });
    typeName.handleChange(e.target.value);
  };

  const categoryChanged = (e, newValue) => {
    categoryError.handleChange({ error: false, text: "" });
    category.handleChange(newValue);
  };

  const typeDescriptionChanged = (e) => {
    typeDescription.handleChange(e.target.value);
  };

  const categoryImagesChanged = (e) => {
    const files = e.target.files;
    categoryImages.handleChange(files);
    selectedFile.handleChange(e.target.value);
  };

  const categoryUtils = {
    page: 1,
    count: 1000,
    tagName: "",
    tagDate: "",
    isLoading: isLoading,
    tags: categories,
  };

  useMountAPI(fetchCategories, categoryUtils);

  const addCounterType = (e) => {
    const name = typeName.value;
    const Category = category.value;
    let description = typeDescription.value;
    let hasError = false;
    const files = categoryImages.value;
    if (name.length == 0) {
      typeNameError.handleChange({
        error: true,
        text: "وارد کردن نوع کنتور الزامی است.",
      });
      hasError = true;
    }
    if (Category.title.length == 0 || Category.id == -1) {
      categoryError.handleChange({
        error: true,
        text: "واردکردن دسته کنتور الزامی است.",
      });
      hasError = true;
    }
    if (description.length == 0) {
      description = "وارد نشده";
    }
    if (hasError) {
      return;
    }

    const json = {
      water_meter_type_name: name,
      water_meter_tag: Category.id,
      water_meter_type_other_information: {
        description: description,
      },
    };

    const data = new FormData();
    data.append("data", JSON.stringify(json));
    if (files.length > 0) {
      data.append("file", files[0]);
    }

    Call("POST", "WaterMeterTypes/admin/add", data)
      .then((response) => {
        if (response.data.code == 200) {
          dispatch(UpdateCounterTypes({ updateCounterTypes: true }));
          typeName.handleChange("");
          typeDescription.handleChange("");
          category.handleChange({ title: "", id: -1 });
          categoryImages.handleChange([]);
          selectedFile.handleChange("");
        }
        // console.log(response);
      })
      .catch((error) => {
        if (error.response) {
          const data = error.response.data;
          // console.log(data);
        }
      });
  };

  return (
    <Grid container style={{ paddingRight: "16px", paddingLeft: "16px" }}>
      <Grid item sx={12} sm={12} md={12} lg={12}>
        <Card style={{ width: "100%", marginTop: "16px" }}>
          <CardHeader
            style={{ borderBottom: "2px solid #e6e9ed", color: "#73879c" }}
            title={"افزودن نوع کنتور جدید"}
            action={
              <ExpandMoree
                expand={expanded.value}
                onClick={handleExpandClick}
                aria-expanded={expanded.value}
                aria-label="show more"
              >
                <ExpandMore />
              </ExpandMoree>
            }
          />
          <Collapse in={expanded.value} timeout="auto" unmountOnExit>
            <CardContent
              style={{
                padding: "16px",
                // maxHeight: "320px",
                overflow: "scroll",
              }}
            >
              <Grid
                container
                style={{ paddingTop: "24px", paddingBottom: "24px" }}
              >
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  style={{
                    paddingRight: "5%",
                    paddingLeft: "5%",
                    marginTop: "16px",
                    marginBottom: "16px",
                  }}
                >
                  <TextField
                    error={typeNameError.value.error}
                    helperText={typeNameError.value.text}
                    onChange={typeNameChanged}
                    value={typeName.value}
                    fullWidth
                    variant="standard"
                    label="نوع کنتور"
                    InputLabelProps={{
                      style: {
                        fontFamily: "Vazir",
                      },
                    }}
                    size="small"
                  ></TextField>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  style={{
                    paddingRight: "5%",
                    paddingLeft: "5%",
                    marginTop: "16px",
                    marginBottom: "16px",
                  }}
                >
                  <Autocomplete
                    onChange={categoryChanged}
                    value={category.value}
                    options={categories.value}
                    getOptionLabel={(option) => option.title}
                    id="disable-close-on-select"
                    // disableCloseOnSelect
                    renderInput={(params) => (
                      <TextField
                        error={categoryError.value.error}
                        helperText={categoryError.value.text}
                        {...params}
                        label="دسته"
                        variant="standard"
                      />
                    )}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  style={{
                    paddingRight: "5%",
                    paddingLeft: "5%",
                    marginTop: "16px",
                    marginBottom: "16px",
                  }}
                >
                  <TextField
                    onChange={typeDescriptionChanged}
                    value={typeDescription.value}
                    fullWidth
                    variant="filled"
                    label="توضیحات نوع کنتور"
                    multiline
                    rows={8}
                    maxRows={12}
                    InputLabelProps={{
                      style: {
                        fontFamily: "Vazir",
                      },
                    }}
                    size="small"
                  ></TextField>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  style={{
                    paddingRight: "5%",
                    paddingLeft: "5%",
                    marginTop: "16px",
                    marginBottom: "16px",
                  }}
                >
                  <Typography>انتخاب تصویر</Typography>
                  <input
                    style={{
                      border: "1px solid #333",
                      padding: "6px",
                      borderRadius: "4px",
                    }}
                    onChange={categoryImagesChanged}
                    value={selectedFile.value}
                    type="file"
                    accept=".jpg, .png, .svg, .PNG, .JPG, .JPEG, .jpeg"
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  style={{
                    paddingRight: "5%",
                    paddingLeft: "5%",
                    marginTop: "16px",
                    marginBottom: "16px",
                  }}
                >
                  <Button
                    onClick={addCounterType}
                    style={{ color: "#fff" }}
                    variant="contained"
                    color="primary"
                  >
                    افزودن
                  </Button>
                </Grid>
              </Grid>
            </CardContent>
          </Collapse>
        </Card>
      </Grid>
    </Grid>
  );
};

export default AddCounterType;

const processTags = (tags) => {
  const results = [];
  let data;
  tags.map((tag) => {
    data = {
      id: tag.water_meter_tag_id,
      title: tag.water_meter_tag_name,
    };
    results.push(data);
  });
  return results;
};

const fetchCategories = (utils) => {
  const page = utils.page;
  const count = utils.count;
  const tagName = utils.tagName;
  const tagDate = utils.tagDate;
  const isLoading = utils.isLoading;
  const tags = utils.tags;

  const data = {
    page: page,
    count: count,
    water_meter_tag_name: tagName,
    water_meter_type_create_date: tagDate,
  };

  Call("POST", "WaterMeterTags/admin/getAll", data)
    .then((response) => {
      if (response.data.code == 200) {
        tags.handleChange(processTags(response.data.data));
        isLoading.handleChange(false);
      }
    })
    .catch((error) => {
      if (error.response) {
        const data = error.response.data;
        // console.log(data);
      }
    });
};
